var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12",
    "data-name": "Group 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.051,
    height: 17.197,
    viewBox: "0 0 16.051 17.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M4.048,8.1A4.048,4.048,0,1,1,8.1,4.048,4.052,4.052,0,0,1,4.048,8.1Zm0-6.774A2.731,2.731,0,1,0,6.779,4.052,2.734,2.734,0,0,0,4.048,1.321Z",
    transform: "translate(3.976 0)",
    fill: "rgba(56,85,114,0.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M11.868,8.368H4.182A4.184,4.184,0,0,1,4.182,0h7.682a4.184,4.184,0,0,1,0,8.368ZM4.182,1.317a2.867,2.867,0,1,0,0,5.734h7.682a2.867,2.867,0,1,0,0-5.734Z",
    transform: "translate(0 8.829)",
    fill: "#363954"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/nameIcon.13691c8a3bbcc9b1e9fa786603a2bfe0.svg";
export { ForwardRef as ReactComponent };